import React, { FC, memo } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { ReactComponent as PlayIcon } from 'assets/images/play.svg'

import styles from './styles.module.scss'

interface IProps {
  videoUrl: string,
  playingVideoUrl: string
  posterUrl: string,
  onClick: (value: string) => void
}

export const VideoCarouselItem: FC<IProps> = memo(({ videoUrl, playingVideoUrl, posterUrl, onClick }) => {
  const handleOnclick = () => {
    if (playingVideoUrl === videoUrl) return
    onClick(videoUrl)
  }
  return (
    <div onClick={handleOnclick}
         className={cn({
           [styles.carouselItem]: true,
           [styles.carouselItemPlaying]: playingVideoUrl === videoUrl,
         })}
         style={{ backgroundImage: `url(${posterUrl})` }}>
      <PlayIcon/>
    </div>
  )
})
